import { baseTheme, Notification, STATUSES, Theme } from 'reapop';

const colorPerStatus = {
  [STATUSES.none]: '#ffffff',
  [STATUSES.info]: '#007bff',
  [STATUSES.loading]: '#007bff',
  [STATUSES.success]: '#28a745',
  [STATUSES.warning]: '#ffc107',
  [STATUSES.error]: '#dc3545',
};
const lineHeight = 1.428571429;

export const lightTheme: Theme = {
  ...baseTheme,
  notification: (notification: Notification) => ({
    display: 'flex',
    width: '400px',
    maxWidth: 'calc(100vw - 32px)',
    height: 'auto',
    position: 'relative',
    // eslint-disable-next-line waldur-custom/enforce-border-radius-tokens
    borderRadius: '12px',
    boxShadow:
      '0 10px 25px -5px rgba(16, 24, 40, .1), 0 8px 10px -6px rgba(16, 24, 40, .04)',
    border: '1px solid rgba(16, 24, 40, 0.08)',
    zIndex: 999,
    backgroundColor: '#ffffff',
    color: '#344054',
    marginBottom: '16px',
    transition: 'all 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
    cursor:
      notification.dismissible && !notification.showDismissButton
        ? 'pointer'
        : '',
  }),
  notificationIcon: (notification: Notification) => ({
    display: notification.image ? 'none' : 'flex',
    width: '38px',
    height: '38px',
    boxSizing: 'border-box',
    margin: 0,
    marginTop: '12px',
    marginBottom: '12px',
    marginInlineStart: '16px',
    marginInlineEnd: '4px',
    alignSelf: 'flex-start',
    flexShrink: 0,
    color: colorPerStatus[notification.status],
  }),
  notificationDismissIcon: () => ({
    width: '16px',
    height: '16px',
    margin: 0,
    marginTop: '14px',
    marginBottom: '0',
    marginInlineStart: '8px',
    marginInlineEnd: '16px',
    cursor: 'pointer',
    color: '#98a2b3',
    flexShrink: 0,
    transition: 'color 0.2s ease, transform 0.2s ease',
  }),
  notificationMeta: () => ({
    verticalAlign: 'top',
    boxSizing: 'border-box',
    width: '100%',
    padding: '14px 8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '40px',
  }),
  notificationTitle: (notification) => ({
    margin: notification.message ? '0 0 4px' : 0,
    fontSize: '14px',
    color: '#101828',
    fontWeight: 600,
    lineHeight,
  }),
  notificationMessage: () => ({
    margin: 0,
    fontSize: '13.5px',
    color: '#475467',
    lineHeight: 1.45,
  }),
  notificationImageContainer: () => ({
    boxSizing: 'border-box',
    padding: '10px 0 10px 15px',
  }),
  notificationImage: () => ({
    display: 'inline-flex',
    borderRadius: '40px',
    width: '40px',
    height: '40px',
    backgroundSize: 'cover',
  }),
  notificationButtons: () => ({}),
  notificationButton: (
    notification: Notification,
    position: number,
    state: { isHovered: boolean; isActive: boolean },
  ) => ({
    display: 'block',
    width: '100%',
    height: `${100 / notification.buttons.length}%`,
    minHeight: '40px',
    boxSizing: 'border-box',
    padding: 0,
    background: 'none',
    border: 'none',
    borderRadius: 0,
    borderLeft: '1px solid rgba(0,0,0,.1)',
    outline: 'none',
    textAlign: 'center',
    color: state.isHovered || state.isActive ? '#007bff' : '#212529',
    cursor: 'pointer',
    borderTop: position === 1 ? '1px solid rgba(0, 0, 0, 0.09)' : 'none',
  }),
  notificationButtonText: () => ({
    display: 'block',
    height: '25px',
    padding: '0 15px',
    minWidth: '90px',
    maxWidth: '150px',
    width: 'auto',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    margin: '0 auto',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '25px',
  }),
};

export const darkTheme: Theme = {
  ...lightTheme,
  notification: (notification: Notification) => ({
    ...lightTheme.notification(notification),
    width: '402px',
    backgroundColor: '#0c111d',
    boxShadow:
      '0 12px 24px -4px rgba(0, 0, 0, .5), 0 6px 10px -2px rgba(0, 0, 0, .3)',
    border: '1px solid #1f242f',
  }),
  notificationDismissIcon: (notification) => ({
    ...lightTheme.notificationDismissIcon(notification),
    color: '#85888e',
  }),
  notificationTitle: (notification) => ({
    ...lightTheme.notificationTitle(notification),
    color: '#f5f5f6',
  }),
  notificationMessage: (notification) => ({
    ...lightTheme.notificationMessage(notification),
    color: '#94969c',
  }),
};
